import { render } from "./ClusterLink.vue?vue&type=template&id=4d7f0128&scoped=true"
import script from "./ClusterLink.vue?vue&type=script&lang=js"
export * from "./ClusterLink.vue?vue&type=script&lang=js"

import "./ClusterLink.vue?vue&type=style&index=0&id=4d7f0128&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d7f0128"]])

export default __exports__